import { render, staticRenderFns } from "./ProductManage.vue?vue&type=template&id=3505e46a"
import script from "./ProductManage.vue?vue&type=script&lang=js"
export * from "./ProductManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports